import { RedirectIcon } from '@/assets/icons/redirect-icon'
import ExpiredLoginImage from '@/assets/images/expired-login.png'
import { InstituitionLogo } from '@/components/instituition-logo'
import { StudentLayout } from '@/components/layout/student'
import { Button } from '@/components/ui/button'
import { useStudentSessionStore } from '@/store/student-session-store'

export const ExpiredToken = () => {
  const { collegeLogo, collegePage } = useStudentSessionStore()

  const navigateToPortal = () => {
    if (collegePage) window.location.href = collegePage
  }

  return (
    <StudentLayout>
      <div className="flex flex-col text-center items-center gap-3">
        <div className="pb-4">
          {collegeLogo && (
            <InstituitionLogo
              imageURL={collegeLogo || ''}
              alt="Logo da Instituição"
              height={45}
              width={170}
            />
          )}
        </div>
        <div className="border-b border-muted-foreground/60 mb-10 w-full"></div>
        <div>
          <span className="text-[var(--brand-blue-2)] text-2xl font-bold">
            Ops, parece que seu token de login expirou!
          </span>
        </div>
        <div>
          <h1 className="text-[var(--brand-gray-2)] font-bold w-130">
            Faça login pelo Portal do Aluno, ou entre em contato diretamente com
            a sua instituição de ensino
          </h1>
        </div>
        <div className="h-87">
          <img src={ExpiredLoginImage} alt="Login Expirado" />
        </div>
        <div className="mt-10">
          {collegePage && (
            <Button className="w-70" onClick={navigateToPortal}>
              Ir para o Portal do Aluno
              <RedirectIcon />
            </Button>
          )}
        </div>
      </div>
    </StudentLayout>
  )
}
